import { classInjector } from '@/lib/utils';

import type { FunctionComponent } from 'react';
import type { TypeLineTableProps } from './types';

/**
 * LineTable es el componente básico de Table.
 */
export const LineTable: FunctionComponent<TypeLineTableProps> = ({
  name,
  value,
  className = '',
  nameClassName = '',
  valueClassName = '',
  children,
  as: HtmlTag = 'span',
}: TypeLineTableProps) => (
  <>
    <div
      className={`u-body u-body--s flex justify-between pb-2 text-typo-primary ${className}`}
    >
      <HtmlTag
        className={`u-body u-body--s text-left text-typo-primary ${nameClassName}`}
      >
        {name}
      </HtmlTag>
      <span
        className={`u-body u-body--s text-right text-typo-primary ${valueClassName}`}
      >
        {value}
      </span>
    </div>
    {children && classInjector('text-typo-tertiary pl-4', children)}
  </>
);
